export default __webpack_public_path__ + "static/media/Martiyers11.6b6c463b.jpg";